import {Document} from '@store/documents';
import {Roles, User} from '@store/settings/users';
import I18n from '@utils/i18n.utils';
import {DocumentInfo} from '@store/files';

export enum AuditInformationTypeEnum {
  CONTACT = 'CONTACT',
  NEED = 'NEED',
  DATA = 'DATA',
  OBSERVATION = 'OBSERVATION',
  MAP = 'MAP',
}

export enum AuditInformationStatusEnum {
  PENDING = 'PENDING',
  VALIDATED = 'VALIDATED',
}

export namespace AuditInformationStatusEnum {
  export const selectItems = () => [
    {label: I18n.t('audits.audit-information.pending'), value: AuditInformationStatusEnum.PENDING},
    {label: I18n.t('audits.audit-information.validated'), value: AuditInformationStatusEnum.VALIDATED},
  ];
}

export enum AuditInformationCreatedFromStepEnum {
  AUDIT = 'AUDIT',
  PREAUDIT = 'PREAUDIT',
}

export enum ContactRoleEnum {
  DEFAULT_INVOICING = 'DEFAULT_INVOICING',
  COMMERCIAL = 'COMMERCIAL',
  HAZARDOUSWASTE = 'HAZARDOUSWASTE',
  SAFETY = 'SAFETY',
  INTERNAL_COMMERCIAL = 'INTERNAL_COMMERCIAL',
  INTERNAL_OPERATIONAL = 'INTERNAL_OPERATIONAL',
  INVOICING_REMINDER = 'INVOICING_REMINDER',
  EXTERNAL_OPERATIONAL = 'EXTERNAL_OPERATIONAL',
  INTERNAL_ADMINISTRATIVE = 'INTERNAL_ADMINISTRATIVE',
  EXTERNAL_ADMINISTRATIVE = 'EXTERNAL_ADMINISTRATIVE',
}

export interface SearchAuditInformationDto {
  step?: AuditInformationCreatedFromStepEnum;
}


export namespace ContactRole {
  export const selectItems = () => [
    {label: I18n.t('global.contactType.invoicing'), value: ContactRoleEnum.DEFAULT_INVOICING},
    {label: I18n.t('global.contactType.commercial'), value: ContactRoleEnum.COMMERCIAL},
    {label: I18n.t('global.contactType.hazardouwaste'), value: ContactRoleEnum.HAZARDOUSWASTE},
    {label: I18n.t('global.contactType.safety'), value: ContactRoleEnum.SAFETY},
    {label: I18n.t('global.contactType.internalCommercial'), value: ContactRoleEnum.INTERNAL_COMMERCIAL},
    {label: I18n.t('global.contactType.internalOperational'), value: ContactRoleEnum.INTERNAL_OPERATIONAL},
    {label: I18n.t('global.contactType.invoicingReminder'), value: ContactRoleEnum.INVOICING_REMINDER},
    {label: I18n.t('global.contactType.externalOperational'), value: ContactRoleEnum.EXTERNAL_OPERATIONAL},
    {label: I18n.t('global.contactType.internalAdministrative'), value: ContactRoleEnum.INTERNAL_ADMINISTRATIVE},
    {label: I18n.t('global.contactType.externalAdministrative'), value: ContactRoleEnum.EXTERNAL_ADMINISTRATIVE}
  ];
}

export interface PositionModel {
  ressourceId: number;
  position: number;
  isOperation?: boolean;
}

export interface RepositionDTO {
  data: PositionModel[];
}

export interface AuditInformationContactModel {
  auditId?: number;
  lastName?: string;
  firstName?: string;
  role?: ContactRoleEnum;
  email?: string;
  phoneNumber?: string;
  codePhone?: string;
  status?: AuditInformationStatusEnum;
  createdFrom?: AuditInformationCreatedFromStepEnum;
}

export interface AuditInformationObservationModel {
  auditId?: number;
  photos?: string[] | Document[];
  addedDocuments?: DocumentInfo[];
  deletedDocuments?: number[];
  observation?: string;
  status?: AuditInformationStatusEnum;
  createdFrom?: AuditInformationCreatedFromStepEnum;
}

export interface AuditInformationMapModel {
  auditId?: number;
  documents?: string[] | Document[];
  addedDocuments?: DocumentInfo[];
  deletedDocuments?: number[];
  status?: AuditInformationStatusEnum;
  legend?: string;
  createdFrom?: AuditInformationCreatedFromStepEnum;
}

export interface AuditInformationNeedModel {
  auditId?: number;
  description?: string;
  status?: AuditInformationStatusEnum;
  createdFrom?: AuditInformationCreatedFromStepEnum;
}

export interface AuditInformationDataModel {
  auditId?: number;
  legend?: string;
  description?: string;
  status?: AuditInformationStatusEnum;
  unit?: string;
  createdFrom?: AuditInformationCreatedFromStepEnum;
}

export interface CreateAuditInformation {
  type: AuditInformationTypeEnum;
  contact?: AuditInformationContactModel;
  map?: AuditInformationMapModel;
  need?: AuditInformationNeedModel;
  data?: AuditInformationDataModel;
  observation?: AuditInformationObservationModel;
}

export interface AuditInformation {
  id: number;
  type: AuditInformationTypeEnum;
  lastName?: string;
  firstName?: string;
  role?: Roles;
  email?: string;
  phoneNumber?: string;
  codePhone?: string;
  description?: string;
  data?: string;
  legend?: string;
  auditId: string;
  position?: number;
  status?: AuditInformationStatusEnum;
  documents?: Document[];
  createdFrom: AuditInformationCreatedFromStepEnum;
  author?: User;
}
